import { render, staticRenderFns } from "./Commodity.vue?vue&type=template&id=7dab31d7"
import script from "./Commodity.vue?vue&type=script&lang=js"
export * from "./Commodity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports